/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "@styles/global.css";
import "react-toastify/dist/ReactToastify.css";
import "@styles/layout.css";
import "@egjs/react-flicking/dist/flicking.css";
import "@egjs/flicking-plugins/dist/pagination.css";
import "@styles/flicking-pagination.css";

import React from "react";
import { type GatsbyBrowser } from "gatsby";

import CookieType from "@constants/CookieType";
import { HelmetProvider } from "@dr.pogodin/react-helmet";
import { recordRouteChange } from "@utilities/checkout-return";
import wrapPageElement from "@wrappers/wrap_page_element";
import Cookies from "js-cookie";

export { wrapPageElement };

// gatsby-plugin-react-i18next redirects an unprefixed URL ("/") to the language
// it keeps in localStorage, a key only this site writes. After a language change
// in the customer area (my.*, which writes the shared `lang` cookie and the
// account language), "/" went to the old language first and layout.tsx switched
// to the new one a moment later. Seed the plugin's key from the shared cookie so
// the first redirect already lands on the chosen language.
export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  const lang = Cookies.get(CookieType.LANG) ?? "";
  if (lang !== "") {
    window.localStorage.setItem("gatsby-i18next-language", lang);
  }
};

// Client counterpart of the provider in gatsby-ssr.tsx;
// @dr.pogodin/react-helmet needs it above every <Helmet>.
export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => <HelmetProvider>{element}</HelmetProvider>;

export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({}) => {
  if (typeof window !== "undefined") {
    const hash = window.location.hash;
    if (hash) {
      // Allow the browser to scroll to the hash target
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return false;
      }
    }
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  }

  return false;
};

export const onPreRouteUpdate: GatsbyBrowser["onPreRouteUpdate"] = ({
  location,
  prevLocation,
}) => {
  recordRouteChange(location, prevLocation);
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({
  prevLocation,
}) => {
  if (
    prevLocation !== null &&
    prevLocation !== undefined &&
    window?.fbq !== undefined
  ) {
    window.fbq("track", "PageView");
  }
};
